import React from "react";
import {
  ModalBackButton,
  ModalContainer,
} from "../../common/components/modules/modal/modalComponents";
import styled from "styled-components";
import SortSelect from "../../common/components/elements/select/SortSelect";
import OrdersList from "./OrdersList";
import useRouter from "../../common/hooks/useRouter";
import Modal from "../../common/components/modules/modal/Modal";
import useAuthentication from "src/core/authentication/hooks/useAuthentication";
import {useOrdersSortBy} from "src/core/user/hooks/useOrdersSortBy";
import Title from "src/core/common/components/modules/Title";

const orderOptions = [
  {label: "Most recent", value: "-created"},
  {label: "Older", value: "created"},
];

/**
 * @return {boolean}
 */
function OrdersBrowser({isOpen, closeModal}) {
  const [sortBy, setSortBy] = useOrdersSortBy(true);
  const router = useRouter();
  const [, Authentication] = useAuthentication();

  const selectedOrder =
    orderOptions.find((opt) => opt.value === sortBy) || orderOptions[0];

  function onChangeOrder(opt) {
    setSortBy(opt.value);
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal}>
      <ModalBackButton onClick={() => router.safeBack()} />
      <ModalContainer>
        <Title>Order History</Title>
        <HorizontalGroup>
          <SortSelect
            orderOptions={orderOptions}
            selectedOrder={selectedOrder}
            onChange={onChangeOrder}
          />
        </HorizontalGroup>
        {!Authentication.isValidating() && Authentication.isLoggedIn() && (
          <OrdersList order={selectedOrder.value} />
        )}
      </ModalContainer>
    </Modal>
  );
}

const HorizontalGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  > *:not(:first-child) {
    margin-left: ${({theme}) => theme.v2.spacing(2)};
  }
  margin-bottom: ${({theme}) => theme.v2.spacing(6)};
`;

export default OrdersBrowser;
